import useFeatureFlags from 'hooks/useFeatureFlags';
import useVersionPreference from 'hooks/useVersionPreference';
import { VERSION_PREFERENCE } from 'hooks/useVersionPreference/constants';

import type { UiVersion } from './types';

const useUiVersion = (): UiVersion => {
    const { V2_RESKIN, V2_RESKIN_CUTOFF } = useFeatureFlags();
    const { preference } = useVersionPreference();

    if (!V2_RESKIN) {
        return VERSION_PREFERENCE.V1;
    }

    if (V2_RESKIN_CUTOFF || preference === VERSION_PREFERENCE.V2) {
        return VERSION_PREFERENCE.V2;
    }

    return VERSION_PREFERENCE.V1;
};

export default useUiVersion;
